<template>
	<v-content>
		<router-view></router-view>
	</v-content>
</template>

<script>
	export default{

	}

</script>

<style scoped>
	
</style>